"use strict";
var dq = function (selector) { return document.querySelector(selector); };
var dqa = function (selector) { return document.querySelectorAll(selector); };
var getById = function (id) { return document.getElementById(id); };
function getCookie(name) {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(";");
    for (var i_1 = 0; i_1 < cookies.length; i_1++) {
        var cookie = cookies[i_1];
        while (cookie.charAt(0) === " ") {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return null;
}
function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + value + expires + "; path=/; domain=" + window.location.hostname;
}
//Load script to block tracking
if (getCookie("blockFbPixel") === "true") {
    var url = document.currentScript.dataset.notracking;
    var script = document.createElement('script');
    script.src = url;
    document.head.appendChild(script);
}
window.theme = window.theme || {};
window.ShopifyCanvas = window.ShopifyCanvas || {};
/*! jQuery v3.6.3 | (c) OpenJS Foundation and other contributors | jquery.org/license */
Shopify.queryParams = {};
if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split("=");
        if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
    }
}
/**
 *
 *  Wrap tables in the RTE with a scrollable div
 *  so they cannot break the layout if too wide
 *
 */
ShopifyCanvas.rteElements = function () {
    var tables = dqa(".rte table");
    tables.forEach(function (table) {
        var _a;
        var wrapper = document.createElement("div");
        wrapper.classList.add("rte__table-wrapper");
        (_a = table.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
};
var _a = getById("theme-strings").dataset, ajaxEnabled = _a.ajaxEnabled, productStockSetting = _a.productStockSetting, stockAvailable = _a.stockAvailable, addToCart = _a.addToCart, soldOut = _a.soldOut, unavailable = _a.unavailable, noStockAvailable = _a.noStockAvailable, willNotShipUntil = _a.willNotShipUntil, totalCartDiscount = _a.totalCartDiscount;
theme.strings = {
    ajaxEnabled: ajaxEnabled,
    productStockSetting: productStockSetting,
    stockAvailable: stockAvailable,
    addToCart: addToCart,
    soldOut: soldOut,
    unavailable: unavailable,
    noStockAvailable: noStockAvailable,
    willNotShipUntil: willNotShipUntil,
    totalCartDiscount: totalCartDiscount,
};
var A11yLmaoHelpers = /** @class */ (function () {
    function A11yLmaoHelpers() {
        var _this = this;
        this.init();
        dqa(".in-page-link").forEach(function (link) {
            link.addEventListener("click", function (event) {
                var currTarget = event.currentTarget;
                _this.pageLinkFocus(getById(currTarget.hash.slice(1)));
            });
        });
    }
    A11yLmaoHelpers.prototype.init = function () {
        // on init, check if we need to set page focus
        var hash = window.location.hash;
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus(getById(hash.slice(1)));
        }
    };
    A11yLmaoHelpers.prototype.handleFocus = function (event) {
        var container = event.currentTarget;
        if (container !== event.target && !container.contains(event.target)) {
            container.focus();
        }
    };
    A11yLmaoHelpers.prototype.trapFocus = function (container, eventNamespace) {
        var _this = this;
        var eventName = eventNamespace ? "focusin." + eventNamespace : "focusin";
        container.setAttribute("tabindex", "-1");
        document.addEventListener(eventName, function (event) { return _this.handleFocus(event); });
    };
    A11yLmaoHelpers.prototype.removeTrapFocus = function (container, eventNamespace) {
        var eventName = eventNamespace ? "focusin." + eventNamespace : "focusin";
        container.removeAttribute("tabindex");
        document.removeEventListener(eventName, this.handleFocus);
    };
    A11yLmaoHelpers.prototype.pageLinkFocus = function (element) {
        if (element) {
            element.tabIndex = -1;
            element.focus();
            element.classList.add("js-focus-hidden");
            element.addEventListener("blur", function () {
                element.classList.remove("js-focus-hidden");
                element.removeAttribute("tabindex");
            });
        }
    };
    return A11yLmaoHelpers;
}());
ShopifyCanvas.A11yHelpers = new A11yLmaoHelpers();
/*
  - Allow product to be added to cart via ajax with
  custom success and error responses.
*/
theme.initCache = function () {
    theme.cache = {
        $drawerSearch: dq(".drawer__search-input"),
        $drawerSearchSubmit: dq(".drawer__search-submit"),
        $stickyBar: getById("StickyBar"),
        $stickyNav: getById("StickyNav"),
        $stickNavWrapper: getById("StickNavWrapper"),
        $stickyNavSearchCart: getById("StickyNavSearchCart"),
        $sortDropdownMobile: getById("SortByMobile"),
        $mobileSort: dq(".mobileSort"),
        $scrollParent: dq("html, body"),
        $siteNav: getById("SiteNav"),
        $siteNavCompressed: getById("SiteNavCompressed"),
        $siteNavParent: getById("SiteNavParent"),
        $siteNavItem: dqa(".site-nav__item"),
        $siteNavSearchCart: getById("SiteNavSearchCart"),
        $mainContent: getById("MainContent"),
        $sortDropdown: getById("SortBy"),
        $tagsDropdown: getById("SortTags"),
        $addToCart: getById("AddToCart"),
        $productPrice: getById("ProductPrice"),
        $comparePrice: getById("ComparePrice"),
        $productStock: getById("ProductStock"),
        $addToCartText: getById("AddToCartText"),
        $productImageModalTrigger: getById("ProductPhotoLink"),
        $productFeaturedImage: getById("ProductPhotoImg"),
        $productThumbs: getById("ProductThumbs"),
        $productThumbArrows: dqa(".product-single__arrow"),
        $productZoomImage: getById("ProductZoomImg"),
        $numberInput: dqa('input[type="number"]'),
    };
    theme.settings = {
        ajaxEnabled: ajaxEnabled,
        productStockSetting: productStockSetting,
        smallBreakpoint: 750, // copied from variables.scss
    };
    theme.productThumbs = {
        index: 0,
        max: 0,
    };
};
document.addEventListener("DOMContentLoaded", function () {
    theme.initCache();
    // Initialize ShopifyCanvas's JS on docready
    ShopifyCanvas.rteElements();
});
